// COLLAPSIBLE FOOTER
document.addEventListener("DOMContentLoaded", function() {
    const footerWraper = document.querySelector('.footer__blocks-wrapper');
    const footerHeading = footerWraper.querySelectorAll('.footer-block__heading');

    if (footerHeading.length > 0) {
        footerHeading.forEach(function(collapFooter) {
            collapFooter.addEventListener('click', function() {
                const parentBlock = collapFooter.closest(".footer-block--menu");
                if (parentBlock) {
                    parentBlock.classList.toggle("open");
                }
            });
        });
    }
});